import { FunctionComponent } from 'react';
import { createUseStyles } from 'react-jss';
import { Box, Typography } from '@mui/material';

const useStyles = createUseStyles({
  container: {
    padding: '30px 0px 10px 0px',
  },
});

const ScreenHeader: FunctionComponent<{ text: string }> = ({ text }) => {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <Typography variant="h1">{text}</Typography>
    </Box>
  );
};

export default ScreenHeader;
